<template>
  <div>
    <div class="top">
      <div class="topleft" @click="$router.push('/rightimfo')" v-if="right">
        <van-icon name="manager-o" color="#ffffff" />教师
      </div>
      <div class="title">教育缴费</div>
      <div class="topright" @click="$router.push('/his')">缴费记录</div>
    </div>
    <div class="contaa">
      <van-image
        v-if="onepic"
        width="10rem"
        height="5rem"
        fit="fill"
        :src="onehead + onepic"
        @click="goother"
      />
      <!-- <van-image
          width="10rem"
          height="5rem"
          fit="fill"
          src="../../assets/logo.png"
          @click="goother"
        /> -->
      <div class="top2">学生信息</div>
      <div class="top3">
        <van-popup v-model="showschool" round position="bottom">
          <van-cascader
            v-model="cascaderValue"
            title="请选择所在班级"
            :options="columns"
            @finish="onFinish"
            active-color="#dd0000"
            @close="showschool = false"
          />
        </van-popup>
        <van-field
          v-model="subdata.class"
          is-link
          readonly
          label="班级："
          placeholder="请选择所在班级"
          @click="showschool = true"
        />
        <van-field
          v-model="subdata.name"
          label="学生："
          placeholder="请输入学生姓名"
        />

        <van-field
          v-model="subdata.idcard"
          label="身份证号码："
          placeholder="请输入身份证号码"
        />

        <div class="tix">注意：请输入正确的学生信息，以免缴费错误！</div>

        <div class="onebtnbox">
          <van-button
            color="#dd0000"
            class="surebtn"
            size="small"
            @click="searchpay"
            plain
            round
            >缴费查询</van-button
          >
        </div>
      </div>
      <div class="top2">缴费信息</div>

      <div class="top4">
        <div v-if="numdata.length > 0">
          <van-cell-group v-for="(item, index) in numdata" :key="index">
            <van-cell
              v-if="item.status == '未支付'"
              class="onecell"
              is-link
              :label="item.endDate"
              @click="gomypaymentimfo(item)"
              ><span style="margin-left: 10px">{{ item.title }}</span
              ><span
                style="
                  font-size: 13px;
                  color: #dd0000;
                  font-weight: 600;
                  width: 70px;
                "
                >{{ item.status }}</span
              >
            </van-cell>
            <van-cell
              class="onecell"
              is-link
              :label="item.endDate"
              v-if="item.status == '已支付'"
              ><span style="margin-left: 10px">{{ item.title }}</span>
              <span
                style="
                  font-size: 13px;
                  color: #00ff00;
                  font-weight: 600;
                  width: 70px;
                "
                >{{ item.status }}</span
              >
            </van-cell>
          </van-cell-group>
          <!-- <div  class="onebox">
              <van-button
               class="onebtn"
                color="#dd0000"
                v-if="newflag && !item.items[0].status"
                @click="createorder(item.items)"
                round
                size="small"
                >立即缴费</van-button
              >
              <van-button
                color="#dd0000"
                class="onebtn"
                v-if="!newflag || item.items[0].status"
                disabled
                round
                size="small"
                >立即缴费</van-button
              >
            </div> -->
        </div>
        <div v-else>
          <van-empty description="暂无支付数据" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      onehead: window.location.origin,
      authTimer: null,
      onepic: "",
      oneurl: "",
      cascaderValue: "",
      numdata: [],
      subdata: {
        name: "",
        idCard: "",
        class: "",
      },
      result: [],
      showschool: false,
      radio: false,
      allprice: 0,
      columns: [],
      orid: "",
      show: false,
      payitems: [],
      right: false,
      newflag: true,
    };
  },

  created() {
    this.gettreedata();
    this.geturl();
    this.gethisa();
    this.getpic();
  },

  methods: {
    getpic() {
      this.fetchget("/api/app/ad/randomAd").then((res) => {
        if (res.code < 0) {
          this.$notify({
            type: "danger",
            message: res.msg,
            color: "#ad0000",
            background: "#ffe1e1",
          });
        } else {
          // console.log(res);
          this.onepic = res.img;
          this.oneurl = res.url;
        }
      });
    },
    //外部页面
    goother() {
      window.open("https://" + this.oneurl);
    },
    gomypaymentimfo(item) {
      this.$router.push({
        path: "/mypaymentimfo",
        query: { id: item.paymentid, studentid: item.studentid },
      });
    },
    gethisa() {
      if (localStorage.getItem("orgId")) {
        this.$set(this.subdata, "name", localStorage.getItem("name"));
        this.$set(this.subdata, "idcard", localStorage.getItem("idCard"));
        this.$set(this.subdata, "class", localStorage.getItem("class"));
        this.orid = localStorage.getItem("orgId");
        // this.subdata.name = localStorage.getItem("name");
        // this.subdata.idcard = localStorage.getItem("idCard");
        // this.subdata.class = localStorage.getItem("class");
      }
    },
    geturl() {
      if (process.env.NODE_ENV != "development") {
        let that = this;
        this.authTimer = setInterval(() => {
          var loginUserStr = localStorage.getItem("APPLOGINUSER");
          if (loginUserStr && loginUserStr != "") {
            var loginUser = JSON.parse(loginUserStr);
            console.log("loginUser", loginUser);
            this.fetchpost("/api/account/appLogin", loginUser)
              .then((res) => {
                if(res.code>0){
                localStorage.setItem("token", res.data.token);
                that.right =
                  res.data.permission.indexOf("Payment.Default.List") >= 0;
                }else {
                    this.$notify({
                  type: "danger",
                  message: res.msg,
                  color: "#ad0000",
                  background: "#ffe1e1",
                });
                }
              
              })
            

            clearInterval(this.authTimer);
          }
        }, 500);

        // let token = url.href.split("scToken=")[1];
        //
        // if (token) {
        //   this.fetchget("api/Account/tokenlogin", { token: token }).then(
        //     (res) => {
        //
        //     }
        //   );
        // } else {
        //   this.$router.push("/empty");
        //   this.$notify({
        //     type: "danger",
        //     message: "请先登录",
        //     color: "#ad0000",
        //     background: "#ffe1e1",
        //   });
        // }
      } else {
        this.right = localStorage.getItem("Payment.Default.List");
      }
    },
    searchpay() {
      this.payitems = [];
      if (!this.orid) {
        this.$notify({
          type: "danger",
          message: "请选择学校班级",
          color: "#ad0000",
          background: "#ffe1e1",
        });
        return;
      }

      if (!this.subdata.name) {
        this.$notify({
          type: "danger",
          message: "请填写学生姓名",
          color: "#ad0000",
          background: "#ffe1e1",
        });
        return;
      }
      if (!this.subdata.idcard) {
        this.$notify({
          type: "danger",
          message: "请填写学生身份证号",
          color: "#ad0000",
          background: "#ffe1e1",
        });
        return;
      }

      this.fetchpost("/api/Order/mypayment", {
        name: this.subdata.name,
        idCard: this.subdata.idcard,
        orgId: this.orid,
      }).then((res) => {
        if (res.code > 0) {
          this.numdata = res.data;
          sessionStorage.setItem("name", this.subdata.name);
          sessionStorage.setItem("idCard", this.subdata.idcard);
          sessionStorage.setItem("orgId", this.orid);
          sessionStorage.setItem("class", this.subdata.class);
          localStorage.setItem("name", this.subdata.name);
          localStorage.setItem("idCard", this.subdata.idcard);
          localStorage.setItem("orgId", this.orid);
        } else {
          this.$notify({
            type: "danger",
            message: res.msg,
            color: "#ad0000",
            background: "#ffe1e1",
          });
        }
      });
    },
    onFinish({ selectedOptions }) {
      this.showschool = false;
      let fieldValue = [];
      selectedOptions.map((option) => fieldValue.push(option));
      // if (fieldValue.length == 4) {
      this.subdata.class =
        fieldValue[fieldValue.length - 3].text +
        fieldValue[fieldValue.length - 2].text +
        fieldValue[fieldValue.length - 1].text;
      sessionStorage.setItem("class", this.subdata.class);
      localStorage.setItem("class", this.subdata.class);
      this.orid = fieldValue[fieldValue.length - 1].value;
      // } else {
      //   this.$notify({
      //     type: "danger",
      //     message: "请选择班级",
      //     color: "#ad0000",
      //     background: "#ffe1e1",
      //   });
      // }
    },
    //获取级联数据
    gettreedata() {
      this.fetchget("api/app/organizationUnit/getOrgTree").then((res) => {
        if (res.code > 0) {
          this.columns = res.data;
        } else {
          this.$notify({
            type: "danger",
            message: res.msg,
            color: "#ad0000",
            background: "#ffe1e1",
          });
        }
      });
    },

    getdata(value) {
      this.$refs.checkboxes[value].toggle();
    },
 
  },
};
</script>

<style lang="scss" scoped>
.onecell {
  min-height: 50px;
  .van-cell__value {
    display: flex;
    width: 100%;
    justify-content: space-around;
  }
}
.onebox {
  width: 345px;
  height: 70px;
  position: relative;
  // border-top: 1px solid #ec8585;
}
.onebtn {
  position: absolute;
  bottom: 20px;
  left: 50%;
  margin-left: -60px;
  width: 120px;
}

.contaa {
  // height:calc(100% - #{$--operation-height});
  overflow-y: auto;
}
.contaa::-webkit-scrollbar {
  display: none;
}
.hidden {
  display: none;
}

.full {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.public-web-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.public-web-container a {
  margin-top: 30px;
}

.wechat-web-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.wechat-web-container wx-open-launch-weapp {
  position: absolute;
  bottom: 40%;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.desktop-web-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.desktop-web-container p {
  position: absolute;
  top: 40%;
}

.public-web-jump-text {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
  margin-top: 24px;
}

.public-web-jump-link {
  transition-property: var(--chakra-transition-property-common);
  transition-duration: var(--chakra-transition-duration-fast);
  transition-timing-function: var(--chakra-transition-easing-ease-out);
  cursor: pointer;
  text-decoration: none;
  outline: transparent solid 2px;
  outline-offset: 2px;
  color: rgb(108, 125, 162);
}

.launch-weapp-button {
  width: 200px;
  height: 45px;
  text-align: center;
  font-size: 17px;
  display: block;
  margin: 0 auto;
  padding: 8px 24px;
  border: none;
  border-radius: 4px;
  background-color: #07c160;
  color: #fff;
}
.top {
  width: 375px;
  height: 44px;
  background-color: #dd0000;
  min-height: 44px;
  text-align: center;
  font-family: MicrosoftYaHei;
  font-size: 17px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 44px;
  letter-spacing: 1px;
  color: #ffffff;
  position: relative;
  .topright {
    font-size: 12px;
    position: absolute;
    right: 15px;
    top: 10px;
    line-height: 20px;
    height: 20px;
    width: 70px;
    border: 1px solid #ffffff;
    border-radius: 8px;
  }
  .topleft {
    font-size: 12px;
    position: absolute;
    left: 15px;
    top: 0px;
  }
}
.top1 {
  width: 375px;
  height: 120px;
  background-color: #ffffff;
  margin-bottom: 7px;
}
.top2 {
  width: 360px;
  height: 40px;
  background-color: #ffffff;
  text-align: left;
  color: #434343;
  font-size: 14px;
  padding-left: 15px;
  font-weight: 600;
  line-height: 40px;
}
.top3 {
  width: 375px;
  min-height: 240px;
  background-color: #ffffff;
  margin-bottom: 7px;
  position: relative;
}
.top4 {
  width: 345px;
  // min-height: 466px;
  background-color: #ffffff;
  padding: 15px 15px;
  position: relative;
  .allcheckradio {
    margin-left: 17px;
    font-size: 15px;
  }
  .tocheck {
    font-size: 15px;
    margin-bottom: 15px;
  }
  .heji {
    width: 345px;
    height: 100px;
    background-color: #ffffff;
    line-height: 100px;
    font-size: 18px;
    color: #313131;
    text-align: center;
    .hejinum {
      font-size: 30px;
      font-weight: 600;
      letter-spacing: 3px;
      color: #dd0000;
    }
    .yuan {
      font-size: 14px;
      font-weight: normal;
      letter-spacing: 1px;
      color: #dd0000;
    }
  }
}
.onebtnbox {
  width: 100%;
  height: 50px;
  //  margin-bottom: 20px;
}
.surebtn {
  width: 120px;
  position: absolute;
  bottom: 15px;
  left: 50%;
  margin-left: -60px;
}
.tix {
  font-size: 11px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  // color: #a0a0a0;
  width: 345px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  margin-top: 10px;
  color: #dd0000;
}
</style>